export const getDriveUrlById = (id) => `https://drive.google.com/uc?export=view&id=${id}`;
